import { matchPath } from 'react-router-dom';
import { path as PagePrivacyPolicyPath } from 'pages/PagePrivacyPolicy';

/**
 * Маршруты, доступные без авторизации.
 *
 * Проверяются в index.tsx до сборки дерева приложения: публичные пути уходят
 * в PublicApp, остальные — в основное дерево с авторизацией. Поэтому список
 * статический, а не проп на <Route>: роутер к этому моменту ещё не смонтирован.
 *
 * Добавляя маршрут сюда, добавьте его и в PublicApp.
 */
export const PUBLIC_ROUTES = [PagePrivacyPolicyPath];

export const isPublicRoute = (pathname: string) =>
  PUBLIC_ROUTES.some((path) => Boolean(matchPath(pathname, { path, exact: true })));
